import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Remove '/src' from the import
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import '@fortawesome/fontawesome-free/css/all.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Auth0Provider
        domain="dev-nlgsh7oi3z7knv1x.us.auth0.com"
        clientId="gUL5KrSHBYrOuKKq4ZiNyqQd3jZjHaOM"
        authorizationParams={{
            redirect_uri: window.location.origin
        }}
    >
<React.StrictMode>
    <App />
  </React.StrictMode>
</Auth0Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();